import type { TicketShow } from '@app-types/ticketSales';
import type { ImmerStateCreator } from '../../../immerStateCreator';
import type { VenuesState } from '../venues.slice';

export type TicketingSalesShow = TicketShow;

export interface ShowsActions {
  initializeShows: (params: { venueId: string; shows: TicketingSalesShow[] }) => void;
}

export type ShowsStore = ShowsActions;

export const createShowsSlice: ImmerStateCreator<ShowsStore> = (set) => ({
  initializeShows: ({ venueId, shows }) =>
    set(
      (state) => {
        const venuesState = state as ShowsStore & VenuesState;
        const venue = venuesState.venuesById[venueId];

        if (!venue) {
          throw new Error(`Venue with id ${venueId} not found`);
        }

        venue.showsById = Object.fromEntries(shows.map((show) => [show.id, show]));
        venue.showsIdOrder = shows.map((show) => show.id);
      },
      false,
      `ticketingSales/initializeShows/${venueId}`,
    ),
});
